import { Outlet } from "@tanstack/react-router";
import DashboardTabs from "./DashboardTabs";

export function DashboardLayout() {
  return (
    <div className="flex flex-col h-full">
      {/* Premium Top Header Tabs */}
      <div className="flex-shrink-0">
        <DashboardTabs />
      </div>

      {/* Content Area - AppLayout owns scrolling */}
      <div className="flex-1 min-h-0 relative z-0 p-6">
        <Outlet />
      </div>
    </div>
  );
}

export default DashboardLayout;
